import React from "react";
import PurchaseProfileForm from "./MyPurchaseProfileForm";
import DashboardSectionWrapper from "../components/DashboardSectionWrapper";

const MyPurchaseProfile = () => {
  return (
    <DashboardSectionWrapper title="My Purchase Profiles">
      <PurchaseProfileForm />
    </DashboardSectionWrapper>
  );
};

export default MyPurchaseProfile;
